// extracted by mini-css-extract-plugin
export default {"container":"statsCard_container__HA5Qq"};